import { render } from "./Construction.vue?vue&type=template&id=4940767e&scoped=true"
import script from "./Construction.vue?vue&type=script&lang=js"
export * from "./Construction.vue?vue&type=script&lang=js"

import "./Construction.vue?vue&type=style&index=0&id=4940767e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4940767e"]])

export default __exports__